
    const original = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"14.68147\" height=\"11.74517\" viewBox=\"0,0,14.68147,11.74517\"><g transform=\"translate(-232.72657,-173.58326)\"><g fill=\"#855cd6\" stroke=\"none\" stroke-width=\"0.5\" stroke-miterlimit=\"10\"><path d=\"M232.72657,181.26044v-1.36109l5.56672,-2.32457l-5.56672,-2.63043v-1.36109l7.26427,3.62449v0.85642zM247.40804,184.33437v0.99406h-6.69842v-0.99406z\"/></g></g></svg><!--rotationCenter:7.27342874096388:6.416737457444697-->";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
